export default {
    /*🤫
🤫
🤫
🤫*/
    slidesToScroll: 1,

    /*🤫
🤫
🤫
🤫*/
    slideSpeed: 300,

    /*🤫
🤫
🤫
🤫*/
    rewindSpeed: 600,

    /*🤫
🤫
🤫
🤫*/
    snapBackSpeed: 200,

    /*🤫
🤫
🤫
🤫
🤫*/
    ease: 'ease',

    /*🤫
🤫
🤫
🤫
🤫*/
    rewind: false,

    /*🤫
🤫
🤫
🤫
🤫*/
    infinite: false,

    /*🤫
🤫
🤫
🤫*/
    initialIndex: 0,

    /*🤫
🤫
🤫
🤫*/
    classNameFrame: 'js_frame',

    /*🤫
🤫
🤫
🤫*/
    classNameSlideContainer: 'js_slides',

    /*🤫
🤫
🤫
🤫*/
    classNamePrevCtrl: 'js_prev',

    /*🤫
🤫
🤫
🤫*/
    classNameNextCtrl: 'js_next',

    /*🤫
🤫
🤫
🤫
🤫*/
    classNameActiveSlide: 'active',

    /*🤫
🤫
🤫
🤫*/
    enableMouseEvents: false,

    /*🤫
🤫
🤫
🤫*/
    window: typeof window !== 'undefined' ? window : null,

    /*🤫
🤫
🤫
🤫*/
    rewindOnResize: true
};
